// removed by extract-text-webpack-plugin
module.exports = {"box":"_35b852ff01_src-projects-_CreateProjectModal_box","bottom":"_490faaef5d_src-projects-_CreateProjectModal_bottom","error":"_19f41149e6_src-projects-_CreateProjectModal_error","dropZone":"_7b5bd4fcba_src-projects-_CreateProjectModal_dropZone","dropZoneActive":"_445b7bfd23_src-projects-_CreateProjectModal_dropZoneActive","templates":"_8edbfc90e9_src-projects-_CreateProjectModal_templates"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/CreateProjectModal.css
// module id = 318
// module chunks = 0